// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionConsulation_root__1va58","title":"SectionConsulation_title__pGVuG","subtitle":"SectionConsulation_subtitle__1FpOJ","services":"SectionConsulation_services__1qOtj"};